import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { motion, AnimatePresence } from "framer-motion";


const TabPorTalento = ({ confirmaciones }) => {
  const [activeTabPerTalent, setActiveTabPerTalent] = useState({});

  const handleTabChange = (talentoId, tabIndex) => {
    setActiveTabPerTalent((prev) => ({ ...prev, [talentoId]: tabIndex }));
  };

  const getActiveTab = (talentoId) => activeTabPerTalent[talentoId] || 0;

  return (
    <div className="row">
      {confirmaciones.map((confirmacion, cardIndex) => {
        const activeTab = getActiveTab(confirmacion.confirmacion_id);

        return (
          <motion.div
            key={confirmacion.confirmacion_id}
            className="col-lg-6 col-12 mb-20"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.1 + cardIndex * 0.08,
              duration: 0.4,
              ease: "easeOut",
            }}
          >
            <div className="card radius-12 h-100 cs-talent-card">
              <div className="card-body p-20">
                {/* Header */}
                <div className="cs-talent-header">
                  <div className="d-flex align-items-center gap-2">
                    <div className="cs-talent-star-wrap">
                      <Icon icon="mdi:star" />
                    </div>
                    <h3 className="cs-talent-name mb-0">
                      {confirmacion.talento}
                    </h3>
                  </div>
                  <span className="cs-talent-badge">
                    {confirmacion.total_selecciones}{" "}
                    {confirmacion.total_selecciones === 1
                      ? "selección"
                      : "selecciones"}
                  </span>
                </div>

                {/* Tabs por pregunta */}
                {confirmacion.resumen && confirmacion.resumen.length > 0 && (
                  <div className="cs-tabs-wrap">
                    {confirmacion.resumen.map((_, qIndex) => (
                      <button
                        key={qIndex}
                        className={`cs-tab-btn ${activeTab === qIndex ? "active" : ""}`}
                        onClick={() =>
                          handleTabChange(confirmacion.confirmacion_id, qIndex)
                        }
                        type="button"
                      >
                        P{qIndex + 1}
                        {activeTab === qIndex && (
                          <motion.div
                            className="cs-tab-indicator"
                            layoutId={`tab-indicator-${confirmacion.confirmacion_id}`}
                          />
                        )}
                      </button>
                    ))}
                  </div>
                )}

                {/* Contenido del tab activo */}
                <AnimatePresence mode="wait">
                  {confirmacion.resumen &&
                    confirmacion.resumen.map((pregunta, qIndex) =>
                      activeTab === qIndex ? (
                        <motion.div
                          key={qIndex}
                          initial={{ opacity: 0, y: 8 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -8 }}
                          transition={{ duration: 0.22 }}
                        >
                          <div className="cs-question-box">
                            <div className="cs-question-icon">
                              <Icon icon="mdi:help-circle-outline" />
                            </div>
                            <p className="cs-question-text mb-0">
                              {pregunta.pregunta}
                            </p>
                          </div>

                          <div className="cs-frases-list">
                            {pregunta.frases_seleccionadas.length === 0 ? (
                              <div className="cs-empty-state">
                                <Icon icon="mdi:minus-circle-outline" />
                                <span>Sin selecciones en esta pregunta</span>
                              </div>
                            ) : (
                              pregunta.frases_seleccionadas.map(
                                (frase, fIndex) => (
                                  <motion.div
                                    key={fIndex}
                                    className="cs-frase-item"
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{
                                      delay: fIndex * 0.06,
                                      duration: 0.26,
                                    }}
                                  >
                                    <div className="cs-frase-check">
                                      <Icon icon="mdi:check" />
                                    </div>
                                    <span className="cs-frase-text">
                                      {frase}
                                    </span>
                                  </motion.div>
                                ),
                              )
                            )}
                          </div>
                        </motion.div>
                      ) : null,
                    )}
                </AnimatePresence>

                {/* Empty si no hay resumen */}
                {(!confirmacion.resumen ||
                  confirmacion.resumen.length === 0) && (
                  <div className="cs-empty-state">
                    <Icon icon="mdi:information-outline" />
                    <span>No hay resultados registrados para este talento</span>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default TabPorTalento;
